<script setup lang="ts">
useSeoMeta({
  title: "Veranstaltungstechnik St. Johann im Pongau – Bühne, Ton & Licht",
  ogTitle: "Veranstaltungstechnik St. Johann im Pongau – Bühne, Ton & Licht | Mody",
  description: "Professionelle Veranstaltungstechnik in St. Johann im Pongau: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik.",
  ogDescription: "Professionelle Veranstaltungstechnik in St. Johann im Pongau: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik.",
})

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Mody Veranstaltungstechnik",
  "url": "https://mody.at/veranstaltungstechnik-st-johann",
  "telephone": "+43 664 2247433",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Flachau",
    "postalCode": "5542",
    "addressRegion": "Salzburg",
    "addressCountry": "AT",
    "streetAddress": "Ennspark 193"
  },
  "areaServed": {
    "@type": "City",
    "name": "St. Johann im Pongau"
  },
  "description": "Professionelle Veranstaltungstechnik in St. Johann im Pongau – Bühne, Ton und Licht für Events jeder Größe."
}

useHead({
  script: [
    { type: 'application/ld+json', innerHTML: localBusinessJsonLd }
  ]
})

const offerings = [
  { icon: 'pi pi-volume-up', title: 'Beschallung', description: 'PA-Systeme für Hallen und Open-Air – skalierbar von kleinen Feiern bis zu großen Konzertbühnen.' },
  { icon: 'pi pi-sun', title: 'Lichttechnik', description: 'Moving Heads, PAR-Strahler, Laser und Hazer – für unvergessliche Licht-Atmosphäre bei jedem Event.' },
  { icon: 'pi pi-home', title: 'Bühne', description: 'Mobiler StageTruck und Bühnenelemente für den Stadtplatz, den Park oder die Veranstaltungshalle.' }
]

const events = ['Stadtfeste', 'Konzerte', 'Firmenfeiern', 'Hochzeiten', 'Maturabälle', 'Vereinsfeste', 'Open-Air-Events', 'Kabarett & Theater', 'Sportveranstaltungen']
const places = ['St. Johann im Pongau', 'Bischofshofen', 'Schwarzach', 'Werfen', 'Radstadt', 'Altenmarkt', 'Flachau', 'Wagrain']
</script>

<template>
  <LandingRegionalEventLanding
    kicker="St. Johann im Pongau"
    title="Veranstaltungstechnik St. Johann im Pongau"
    hero-description="Professionelle Bühne, Ton & Licht für Events in St. Johann im Pongau – zuverlässig, erfahren und persönlich."
    intro-heading="Euer Partner für Events in St. Johann im Pongau"
    :intro-paragraphs="[
      'St. Johann im Pongau ist das Zentrum des Pongaus – mit einer lebhaften Veranstaltungsszene rund ums Jahr. Mody Veranstaltungstechnik beliefert Events in St. Johann und der gesamten Region seit über 25 Jahren mit professionellem Equipment.',
      'Von Konzerten in der Mehrzweckhalle bis zu Open-Air-Events am Stadtplatz – wir kennen die Locations und wissen, was es braucht.'
    ]"
    offerings-heading="Was wir in St. Johann anbieten"
    :offerings="offerings"
    events-heading="Events, die wir in St. Johann betreuen"
    :events="events"
    service-heading="St. Johann und Umgebung"
    service-description="Wir betreuen Events in St. Johann im Pongau und der gesamten Region."
    :places="places"
    cta-heading="Jetzt Angebot für euer St. Johann-Event anfragen"
    cta-description="Kostenlos & unverbindlich. Wir melden uns schnell zurück mit einem individuellen Angebot."
  />
</template>
